module.exports = __webpack_public_path__ + "icomoon.2c4d61b.eot";